import * as navigationAction from './navigationAction';
import * as networkAction from './networkAction';
import * as dataAction from './data';

export const ActionCreators = Object.assign({},
     navigationAction,
     networkAction,
     dataAction
    )
